import { AvailableViewSummary } from '../contracts/availableViews';
import { RecipeGroupId } from '../contracts/recipes';

export interface SurveyDataManagerEntitlements {
  readonly allowedGroupIds: readonly RecipeGroupId[];
  readonly allowedRecipeIds: 'all' | readonly string[];
  readonly showStaffVisualisationSettings: boolean;
}

export function canShowStaffVisualisationSettings(): boolean {
  return (
    process.env.REACT_APP_SDM_SHOW_STAFF_VISUALISATION_SETTINGS?.trim().toLowerCase() ===
    'true'
  );
}

export function getStubEntitlements(): SurveyDataManagerEntitlements {
  const hideClientViews =
    process.env.REACT_APP_SDM_HIDE_CLIENT_VIEWS?.trim().toLowerCase() === 'true';

  const allowedGroupIds: RecipeGroupId[] = hideClientViews
    ? ['ptsStandard', 'myLayers']
    : ['ptsStandard', 'clientStandard', 'myLayers'];

  return {
    allowedGroupIds,
    allowedRecipeIds: 'all',
    showStaffVisualisationSettings: canShowStaffVisualisationSettings(),
  };
}

export function isGroupEntitled(
  groupId: RecipeGroupId,
  entitlements: SurveyDataManagerEntitlements = getStubEntitlements(),
): boolean {
  return entitlements.allowedGroupIds.includes(groupId);
}

export function isRecipeEntitled(
  recipeId: string,
  entitlements: SurveyDataManagerEntitlements = getStubEntitlements(),
): boolean {
  if (entitlements.allowedRecipeIds === 'all') {
    return true;
  }
  return entitlements.allowedRecipeIds.includes(recipeId);
}

export function filterEntitledViews(
  views: readonly AvailableViewSummary[],
  entitlements: SurveyDataManagerEntitlements = getStubEntitlements(),
): readonly AvailableViewSummary[] {
  return views.filter(
    (view) =>
      isGroupEntitled(view.groupId, entitlements) &&
      isRecipeEntitled(view.id, entitlements),
  );
}
